module["exports"] = [
  "#####"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/es/address/postcode.js
// module id = 1229
// module chunks = 1